import useSearchParams from '@component/hooks/search/searchParams/useSearchParams';
import { generateParams } from '@component/hooks/search/searchParams/urlParams';

const usePostParams = () => {
  const { selectedOptions, queryKey, pageNum, pageSize, sortType } = useSearchParams();

  return generateParams({
    selectedOptions,
    queryKey,
    pageNum,
    pageSize,
    sortType,
  });
};

export default usePostParams;
